import { useCallback, useContext, useMemo } from 'react';
import { SubscriptionsContext } from "../contexts/SubscriptionsContext";
import { FeatureTypes } from 'src/@types/feature';

// ----------------------------------------------------------------------

const useFeatures = () => {
    const context = useContext(SubscriptionsContext);
    if (!context) throw new Error('Subscription context must be use inside SubscriptionContextProvider');
    const { features, isFeaturesLoading } = context;

    const landingPageCreate = useMemo((): boolean => {
        return features?.some((feature) => feature.code === FeatureTypes.LANDING_PAGE);
    }, [features]);

    const landingPagePublish = useMemo(() => {
        return features?.some((feature) => feature.code === FeatureTypes.LANDING_PAGE_PUBLISH);
    }, [features]);

    const merchantThemeSettingsUpdate = useMemo((): boolean => {
        return features?.some((feature) => feature.code === FeatureTypes.MERCHANT_THEME_SETTINGS);
    }, [features]);

    const interactiveToolsFeature = useMemo((): boolean => {
        return features?.some((feature) => feature.code === FeatureTypes.INTERACTIVE_TOOLS);
    }, [features]);

    const displayCustomerEmailFeature = useMemo((): boolean => {
        return features?.some((feature) => feature.code === FeatureTypes.DISPLAY_CUSTOMER_EMAIL);
    }, [features]);

    const impactWidgetFeature = useMemo((): boolean => {
        return features?.some((feature) => feature.code === FeatureTypes.IMPACT_WIDGET);
    }, [features]);

    const isFeatureAvailable = useCallback((featureCode: keyof typeof FeatureTypes | undefined | string) => {
        return features?.some((feature) => feature.code === featureCode);
    }, [features]);

    return {
        landingPageCreate,
        landingPagePublish,
        merchantThemeSettingsUpdate,
        isFeaturesLoading,
        interactiveToolsFeature,
        displayCustomerEmailFeature,
        impactWidgetFeature,
        isFeatureAvailable,
    };
};

export default useFeatures;
